import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const FactorOuterWrapper = styled(Box)(`
    display:flex;
    flex-direction:column;
    position: relative;
    width:100%;
    overflow:auto;

    .smallCircle.hovered-circle {
      stroke: #095BBD !important;
      stroke-width: 1 !important;
    }

    .smallCircleText.hovered-text {
      fill: #095BBD !important;
    }

    .links path.hovered-link {
      stroke: #095BBD !important;
    }
`)

export const LegendWrapper = styled(Box)(`
  padding:0 10px 10px 10px;
  display: flex;
  justify-content: start;
  flex-direction:column;

  & p {
    font-size: 12px;
    font-weight: 400; // 300;
    width:100%;
    text-align: left;
  }

  & .legendRoot {
    justify-content: end;
  }

`)

export const TitleFromTo = styled(Box)(`
    background: 
      url('data:image/svg+xml;utf8,<svg width="13" height="38" viewBox="0 0 13 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.3536 9.35355C12.5488 9.15829 12.5488 8.84171 12.3536 8.64645L9.17157 5.46447C8.97631 5.2692 8.65973 5.2692 8.46447 5.46447C8.2692 5.65973 8.2692 5.97631 8.46447 6.17157L11.2929 9L8.46447 11.8284C8.2692 12.0237 8.2692 12.3403 8.46447 12.5355C8.65973 12.7308 8.97631 12.7308 9.17157 12.5355L12.3536 9.35355ZM1 9V8.5H0.5V9H1ZM1 29H0.5V29.5H1V29ZM12.3536 29.3536C12.5488 29.1583 12.5488 28.8417 12.3536 28.6464L9.17157 25.4645C8.97631 25.2692 8.65973 25.2692 8.46447 25.4645C8.2692 25.6597 8.2692 25.9763 8.46447 26.1716L11.2929 29L8.46447 31.8284C8.2692 32.0237 8.2692 32.3403 8.46447 32.5355C8.65973 32.7308 8.97631 32.7308 9.17157 32.5355L12.3536 29.3536ZM12 9V8.5H1V9V9.5H12V9ZM1 9H0.5V29H1H1.5V9H1ZM1 29V29.5H12V29V28.5H1V29Z" fill="black"/></svg>')
      no-repeat left top;
    width:100%;
    min-height: 40px;
    display: block;
    padding-left: 18px;
    font-size: 13px;
    font-weight: 600;
    line-height: 19px;
`)

export const Percentage = styled(Box)(`
  position: absolute;
  top:0;
  right:0;
  border: 1px #000 solid;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 40px;
  text-align:center;
`)

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

const getCircleWidth = ({ size }) => {
  const s = size * 2
  return s > 110 ? 110 : s
}
const getCircleHeight = () => {
  return 160
}

export const PptOuterWrapper = styled(Box)(`
    height:550px;
    width:1200px;
    position:relative;
    display:flex;
`)
export const PptGraph = styled(Box)(
  (props) => `
    transform:scale(0.92);
    height:650px;
    width:800px;
    position:relative;
    margin:-30px auto 0;

    & .wrap_0 { left:calc(50% - 95px); top:calc(50% - ${getCircleHeight() / 2}px); }
    & .wrap_0 .bigCircle {  margin-left:0; }
    & .wrap_0 .smallCircle { display:none; }
    & .wrap_0 .line { display:none; }

    & .wrap_1 { left:10px; top:calc(50% - ${getCircleHeight() / 2}px); }
    & .wrap_2 {
        left: 90px; top: 110px; transform:rotate(60deg);
        & .circles {transform:rotate(-60deg)}
    }
    & .wrap_3 {
        left:255px; top:110px; transform:rotate(125deg);
        & .circles {transform:rotate(-125deg)}
    }
    & .wrap_4 {
        left:calc(50% - 20px); top:calc(50% - ${getCircleHeight(props) / 2}px); transform:rotate(180deg);
        & .circles {transform:rotate(-180deg)}
    }
    & .wrap_5 {
        left:240px; top:370px; transform:rotate(245deg);
        & .circles {transform:rotate(-245deg)}
    }
    & .wrap_6 {
        left:105px; top:370px; transform:rotate(295deg);
        & .circles {transform:rotate(-295deg)}
    }
`)

export const PptInnerWrapper = styled(Box)(`
    width:50%;
    height:${getCircleHeight()}px;
    position: absolute;
    display: flex;
    justify-content: start;
    align-items: center;
`)

export const BigCircle = styled(Box)(
  (props) => `
    background: #d3d3d3;
    width:${getCircleWidth(props)}px;
    height:${getCircleWidth(props)}px;
    max-width:${getCircleWidth(props)}px;
    max-height:${getCircleWidth(props)}px;
    display:flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius:50%;
    font-size:15px;
    line-height:15px;
    z-index:1;
    margin-left:20px;
    padding:10px;
`
)

export const SmallCircle = styled(Box)(`
    width:30px;
    height:30px;
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius:50%;
    background:#fff;
    border:1px #000 solid;
    font-size:12px;
    position: absolute;
    left:calc(50% + 15px);
    top:calc(50% - 15px);
    z-index:1;
`)

export const Line = styled(Box)(`
    width:calc(100% - 60px);
    height:1px;
    background:#000;
    position: absolute;
    left:30px;
    top:50%;
`)

export const FactorNewComponent = styled(Box)(`
    svg { width: 100%; height: 100vh; }
    text.label {
      font-family: sans-serif;
      font-size: 12px;
      fill: #333;
      pointer-events: none;
    }
    text.link-val {
      font-family: sans-serif;
      font-size: 10px;
      fill: #000;
      pointer-events: none;
    }

    /* default opacity */
    circle, path, text {
      opacity: 1;
    }
    .active {
      opacity: 1 !important;
    }
    .inactive {
      opacity: 0.5 !important;
    }
`)
